import React from "react";
import { FaPen } from "react-icons/fa";

export default function Edit(props) {

  return (
    <>
      <div className="icon-button">
        <FaPen/>
      </div>
    </>
  );
}
